import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PasswordCheckService {
    private readonly apiUrl = `${environment.url}/api`; 

    constructor(private http: HttpClient) { }

    // Queries PasswordUpdates to compare the new password to the user's previous X passwords
    // X previous password policies is retrieved and determined on the back end
    async checkPreviousPasswords(userId: string, newPassword: string): Promise<boolean> {
        try {
            const response = await this.http.post(
                `${this.apiUrl}/PasswordCheck/CheckPreviousPasswords`,
                { userId, newPassword },
                { observe: 'response' }
            ).toPromise();

            // Password Accepted (200 OK)
            console.log('[Service] Password check success:', response.status);
            return true;
        } catch (error: any) {
            // Password is reused error
            if (error.status === 400) {
                console.warn('[Service] Password is reused (400):', error);
                return false;
            } else {
                // Other error
                console.error('[Service] Password check failed:', error);
                return false;
            }
        }
    }

    // Saves the new password into the PasswordUpdates table
    async saveNewPassword(userId: string, newPassword: string): Promise<void> {
        await this.http.post<void>(
            `${this.apiUrl}/PasswordCheck/StoreNewPassword`,
            { UserId: userId, NewPassword: newPassword }
        ).toPromise();
    }

    // Checks if user's most recent password update is within allowed age (e.g., 90 days)
    async checkPasswordAge(userId: string): Promise<boolean> {
        try {
            const response = await this.http.post(`${this.apiUrl}/PasswordCheck/CheckPasswordAge`, { userId }, { observe: 'response' }).toPromise();
            console.log('[Service] Password age OK:', response.status);
            return true;
        } catch (error: any) {
            if (error.status === 400) {
                console.warn('[Service] Password outdated (400)', error);
                return false;
            } else {
                console.error('[Service] Unexpected error:', error);
                return false;
            }
        }
    }

    // Checks the password for any user details via id
    // Used by user-editor
    async checkPasswordForPii(userId: string, newPassword: string): Promise<boolean> {
        try {
            const response = await this.http.post(
                `${this.apiUrl}/PasswordCheck/CheckUserDetailsById`,
                { userId, newPassword },
                { observe: 'response' }
            ).toPromise();

            console.log('[Service] Password PII check (by ID) passed:', response.status);
            return true;
        } catch (error: any) {
            if (error.status === 400) {
                console.warn('[Service] Password contains PII (400):', error);
                return false;
            } else {
                console.error('[Service] Password PII check failed:', error);
                return false;
            }
        }
    }
}